export default __webpack_public_path__ + "images/smile_scan_star.a0999fd2bf6d61c6ead1063f5acff778.svg";